export const questionsTemplate = [
  {
    "key": "in_neighborhood",
    "question": "In which area(s) would you like to focus new housing development?",
    "description":"Building in the city center tends to be the most costly, while construction in residential areas will cause disruption to citizens. Formerly industrial land can provide significant area for development, but the cost of making it livable can be high.",
    "values": [
      "City Center",
      "Residential",
      "Industrial"
    ],
    "type": "input",
    "index": 1,
    "answer": [
      0
    ],
    "descriptionToggle": false
  },
  {
    "key": "in_vacancy_type",
    "question": "On what type(s) of land there would you like to build housing?",
    "description": "Developing land with unoccupied buildings has a cost associated with demolition and/or renovation. Construction on occupied dwellings means rehousing existing tenants before rebuilding.",
    "values": [
      "Empty Lot",
      "Unoccupied Building",
      "Occupied Building"
    ],
    "type": "input",
    "index": 2,
    "answer": [
      0
    ],
    "descriptionToggle": false
  },
  {
    "key":"in_solar_panels",
    "question": "How much of the land do you want to devote to clean energy generation?",
    "description": "Placing solar panels on the land enables energy self-reliance for the city, though the decision directly reduces the amount of land available for housing or public space.",
    "options": [
      { text: 'none', value: "0" },
      { text: 'some', value: "0.33" },
      { text: 'a lot', value: "0.66" },
      { text: 'max', value: "1"}
    ],
    "type": "radio",
    "index": 4,
    "answer": "0",
    "descriptionToggle": false
  },
  {
    "key":"in_public_space",
    "question": "How much of the land do you want to devote to public space?",
    "description": "Access to public space, like parks and plazas, is important for residents’ wellbeing, though more public space reduces the amount of land available for housing or energy generation.",
    "options": [
      { text: 'none', value: "0" },
      { text: 'some', value: "0.33" },
      { text: 'a lot', value: "0.66" },
      { text: 'max', value: "1"}
    ],
    "type": "radio",
    "index": 6,
    "answer": "0",
    "descriptionToggle": false
  },
  {
    "key":"in_commercial",
    "question": "How much development should be for commercial buildings instead of housing?",
    "description":"Commercial spaces, such as gyms, markets, and restaurants, add amenities and employment opportunities for residents.",
    "options": [
      { text: 'none', value: "0" },
      { text: 'some', value: "0.33" },
      { text: 'a lot', value: "0.66" },
      { text: 'max', value: "1"}
    ],
    "type": "radio",
    "index": 8,
    "answer": "0",
    "descriptionToggle": false
  },
  {
    "key":"in_convert_industry",
    "question": "Convert in-use industrial buildings into housing units? ",
    "description":"This drastic move would allow for more housing, but at the cost of employment opportunities.",
    "options": [
      { text: 'yes', value: "1" },
      { text: 'no', value: "0" },
    ],
    "type": "radio",
    "index": 10,
    "answer": "1",
    "descriptionToggle": false
  }
]